import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { Injectable } from '@angular/core';

export interface FeatureAccessResettable {
  resetFeatureCache(): void;
}

@Injectable({ providedIn: 'root' })

export class FeatureAccessResetService {

  private resettables: FeatureAccessResettable[]=[];

  constructor(
    private exceptionsService: ExceptionsService
  ) { }

  public register(resettable: FeatureAccessResettable): void {
    try {
      if (!resettable)
        return;

      if (this.resettables.indexOf(resettable)>=0)
        return;

      this.resettables.push(resettable);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetAll(): void {
    try {
      this.resettables.forEach((resettable: FeatureAccessResettable) => {
        try {
          resettable?.resetFeatureCache();
        }
        catch(e) {
          this.exceptionsService.handleException(<Error>e);
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
